import { formatMoney } from "@dk/api-client"
import { useBootstrapStore } from "../stores/bootstrap"

// money formats cents in the store's currency (falls back to USD before boot).
export function money(cents: number | undefined | null): string {
  if (cents == null) return ""
  const currency = useBootstrapStore().payload?.store?.currency ?? "USD"
  return formatMoney(cents, currency)
}
